'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _urls = require('../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _discoverItems = require('../../redux/modules/discoverItems');

var _categoryGrabber = require('../../utils/categoryGrabber');

var _components = require('../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DiscoverItems = require('./DiscoverItems.scss');

var _DiscoverItems2 = _interopRequireDefault(_DiscoverItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscoverItems = function (_Component) {
    (0, _inherits3.default)(DiscoverItems, _Component);

    function DiscoverItems() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DiscoverItems);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DiscoverItems.__proto__ || (0, _getPrototypeOf2.default)(DiscoverItems)).call.apply(_ref, [this].concat(args))), _this), _this.getAuctionHouseLink = function () {
            return (0, _jsx3.default)('div', {}, _this.props.seller.sellerId + '-' + _this.props.seller.name, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getSellerUrl)(_this.props.seller.sellerId, _this.props.seller.name)
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'more_auctions_auctioneer'
            })));
        }, _this.getSimilarItemsLink = function () {
            var searchUrl = (0, _urls.getSimilarItemsUrl)(_this.props.item.title);

            return (0, _jsx3.default)('div', {}, 'similar-items', (0, _jsx3.default)(_components.Link, {
                route: true,
                to: searchUrl
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'similar_items'
            })));
        }, _this.getAuctioneerSimilarItemsLink = function () {
            var _this$props$item$titl = _this.props.item.title,
                title = _this$props$item$titl === undefined ? '' : _this$props$item$titl;

            var keyword = title.split(/\s+/g).map(function (word) {
                return '"' + word + '"';
            }).join(' OR ').replace(/"/g, '\\"');
            var params = '?parameters=' + encodeURIComponent('{"keyword":"' + keyword + '","status":["online", "live", "upcoming"], "house_id": "' + _this.props.seller.sellerId + '"}');
            var searchUrl = '/search' + params;
            return (0, _jsx3.default)('div', {}, 'similar-auctioneer-items', (0, _jsx3.default)(_components.Link, {
                route: true,
                to: searchUrl
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'similar_items_auctioneer'
            })));
        }, _this.getAuctionPriceResultsLink = function () {
            var facets = _this.props.facets;

            if (facets && facets.creators && facets.creators.length > 0) {
                var creator = (0, _categoryGrabber.getCategoryLevel)(facets.creators[0]);
                return (0, _jsx3.default)('div', {}, 'creator-price-guide-link', (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: (0, _urls.getPriceGuideUrl)(creator.categoryUrl, creator.categoryId)
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'price_guid_discover',
                    values: { token: creator.categoryLabel }
                })));
            }
            return null;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DiscoverItems, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'facets', 'item', 'seller']);
        }
    }, {
        key: 'render',
        value: function render() {
            var auctionHouse = this.getAuctionHouseLink();
            var similarItems = this.getSimilarItemsLink();
            var similarAuctioneerItems = this.getAuctioneerSimilarItemsLink();
            var auctionPriceResultsLink = this.getAuctionPriceResultsLink();
            var links = (0, _discoverItems.generateDiscoverLinks)(this.props.facets, DiscoverItems.createCategoryLandingLink);
            var classes = (0, _classnames2.default)(_DiscoverItems2.default['discover-items'], this.props.className);
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _DiscoverItems2.default.header
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'discover_items'
            })), (0, _jsx3.default)('div', {
                className: _DiscoverItems2.default.links
            }, void 0, links, auctionPriceResultsLink, auctionHouse, similarAuctioneerItems, similarItems));
        }
    }], [{
        key: 'createCategoryLandingLink',
        value: function createCategoryLandingLink(mainItem, secondItem) {
            var link = '';
            mainItem = (0, _categoryGrabber.getCategoryLevel)(mainItem);
            secondItem = (0, _categoryGrabber.getCategoryLevel)(secondItem);
            if (secondItem.categoryUrl) {
                link = (0, _jsx3.default)('div', {}, mainItem.categoryLabel + '-' + secondItem.categoryLabel, (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/c/' + mainItem.categoryUrl + '/' + secondItem.categoryUrl + '/' + mainItem.categoryId + '/' + secondItem.categoryId + '/'
                }, void 0, secondItem.categoryLabel + ' ' + mainItem.categoryLabel));
            } else if (mainItem) {
                link = (0, _jsx3.default)('div', {}, mainItem.categoryLabel + '}', (0, _jsx3.default)(_components.Link, {
                    route: true,
                    to: '/c/' + mainItem.categoryUrl + '/' + mainItem.categoryId + '/'
                }, void 0, '' + mainItem.categoryLabel));
            }
            return link;
        }
    }]);
    return DiscoverItems;
}(_react.Component);

exports.default = DiscoverItems;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DiscoverItems/DiscoverItems.js
// module id = XoDl
// module chunks = 57